/**
 * Преобразует имя исходного файла в имя выходного файла Fantom
 * (вставляет `.fantom.` перед расширением). Если расширения нет,
 * просто добавляет `.fantom.mid` в конец. Пустое имя или имя,
 * состоящее только из точек, превращается в `fantom.mid` без
 * лидирующей точки (иначе на Unix получится скрытый файл).
 *
 * Примеры:
 *   toFantomName("song.mid")   → "song.fantom.mid"
 *   toFantomName("Песня.mid")  → "Песня.fantom.mid"
 *   toFantomName("song")       → "song.fantom.mid"
 *   toFantomName("")           → "fantom.mid"
 *   toFantomName(".")          → "fantom.mid"
 */
export const toFantomName = (name: string): string => {
  const trimmed = name.trim();
  if (trimmed === "" || trimmed === ".") return "fantom.mid";
  const dot = trimmed.lastIndexOf(".");
  if (dot <= 0) return `${trimmed}.fantom.mid`;
  return `${trimmed.slice(0, dot)}.fantom.mid`;
};